export default {
  state: {
    headers: {
      'Authorization': '' // Authorization Token
    },
    loading: {
      requestCount: 0,
      isVisible: false
    },
    language: 'ar'
  },
  mutations: {
    SET_AUTH_HEADER: (state, token) => {
      state.headers['Authorization'] = token
    },
    SET_INIT_AUTH_HEADER: (state) => {
      state.headers['Authorization'] = ''
    },
    PUSH_REQUEST_COUNT: (state) => {
      state.loading.requestCount++
      setTimeout(function() {
        state.loading.isVisible = state.loading.requestCount > 0
      }, process.env.VUE_APP_LOADING_DELAY)
    },
    POP_REQUEST_COUNT: (state) => {
      state.loading.requestCount--
      if (state.loading.isVisible && state.loading.requestCount < 1) {
        state.loading.isVisible = false
      }
    },
    SET_LANGUAGE: (state, lang) => {
      state.language = lang
    },
    INIT_REQUEST_COUNT: (state) => {
      state.loading.isVisible = false
      state.loading.requestCount = 0
    }
  },
  actions: {
    SetInitAuthHeader ({ commit }) {
      commit('SET_INIT_AUTH_HEADER')
    },
    SetAuthHeader ({ commit }, token) {
      commit('SET_AUTH_HEADER', token)
    },
    RequestApi ({ commit }) {
      commit('PUSH_REQUEST_COUNT')
    },
    ResponseApi ({ commit }) {
      commit('POP_REQUEST_COUNT')
    },
    SetLanguage ({ commit }, lang) {
      commit('SET_LANGUAGE', lang)
    },
    SetInitRequestApi ({ commit}) {
      commit('INIT_REQUEST_COUNT')
    }
  }
}
